export default "__VITE_ASSET__5d2355b1__"